<template>
	<svg
		width="167"
		height="70"
		viewBox="0 0 167 70"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M129 70H46C42.134 70 39 66.866 39 63C39 59.134 42.134 56 46 56H7C3.13401 56 0 52.866 0 49C0 45.134 3.13401 42 7 42H47C50.866 42 54 38.866 54 35C54 31.134 50.866 28 47 28H22C18.134 28 15 24.866 15 21C15 17.134 18.134 14 22 14H62C58.134 14 55 10.866 55 7C55 3.13401 58.134 0 62 0H160C163.866 0 167 3.13401 167 7C167 10.866 163.866 14 160 14H120C123.866 14 127 17.134 127 21C127 24.866 123.866 28 120 28H142C145.866 28 149 31.134 149 35C149 38.866 145.866 42 142 42H131.826C126.952 42 123 45.134 123 49C123 52.866 129 56 129 56C132.866 56 136 59.134 136 63C136 66.866 132.866 70 129 70Z"
			fill="currentColor"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M160 42C156.134 42 153 38.866 153 35C153 31.134 156.134 28 160 28C163.866 28 167 31.134 167 35C167 38.866 163.866 42 160 42Z"
			fill="currentColor"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconBackdrop',
}
</script>
